<template>
  <div class="areas-body-div col-12 banCopy transition">
    <ul class="areas-list list-unstyled">
      <li
        class="areas-list-item mouseLink"
        ref="zoom"
        v-for="item in areasArr"
        :key="item"
        @click="gotoBusinessDetails(item.title, item.company_id)"
      >
        <div class="areas-item-box">
          <div class="areas-img-box">
            <img class="areas-img" :src="item.img_url" />
          </div>
          <div class="areas-item-title-box">
            <h5 class="areas-item-title">{{ item.title }}</h5>
          </div>

          <div class="areas-modal-div">
            <h4 class="areas-modal-title">{{ item.title }}</h4>
            <h6 class="areas-modal-content" v-html="item.outline"></h6>
            <div class="banCopy areas-modal-button mouseLink">查看详情</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title="杭开集团-业务领域";

    this.Post();
  },
  methods: {
    gotoBusinessDetails(title, id) {
      this.$router.push({
        name: "businessDetails",
        query: {
          title: title,
          companyid: id,
        },
      });
    },
    Post() {
      var url = "http://demoapi.hkjt.cn/pages/business.php";

      this.axios
        .get(url)
        .then((res) => {
          this.areasArr = res.data;
        })
        .catch((e) => {
          if (e.response) {
            //请求已发出，服务器返回状态码不是2xx。
            console.info(e.response.data);
            console.info(e.response.status);
            console.info(e.response.headers);
          } else if (e.request) {
            // 请求已发出，但没有收到响应
            // e.request 在浏览器里是一个XMLHttpRequest实例，
            // 在node中是一个http.ClientRequest实例
            console.info(e.request);
          } else {
            //发送请求时异常，捕捉到错误
            console.info("error", e.message);
          }
          console.info(e.config);
        });
    },
  },
  data() {
    return {
      areasArr: [],
    };
  },
};
</script>

<style scoped>
@keyframes dispaly-box {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes show-box {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes move-up {
  0% {
    opacity: 0;
    transform: translateY(+500px);
  }

  100% {
    opacity: 1;
  }
}

.areas-move-up {
  animation: move-up 1.5s;
}

.areas-body-div {
  width: 100vw;
  background-color: transparent;
  transition-duration: 0.8s;
  margin-top: 12rem;
}

.areas-img-box {
  overflow: hidden;
  width: 100%;
}

.areas-list-item {
  width: 27rem;
  margin-bottom: 3.75rem;
  transition-duration: 0.8s;
  background-color: #fff;
}

.areas-list {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 100rem;
  margin: 0 auto;
}

.areas-item-box {
  height: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 0.375rem;
  /* margin: 0 3.75rem 3.75rem 0; */
  position: relative;
  border-radius: 0.3rem;
  overflow: hidden;
}

.areas-item-box:hover .areas-img {
  transform: scale(1.2);
  transition-duration: 0.5s;
}

.areas-item-box:hover .areas-item-title {
  color: #237efe;
}

.areas-item-title-box {
  height: 0;
  padding-top: 50%;
  position: relative;
}

.areas-item-title {
  color: #363636;
  letter-spacing: 0.2rem;
  position: absolute;
  top: 1rem;
  left: 1rem;
}

.areas-img {
  width: 100%;
  transition-duration: 0.3s;
}

.areas-modal-div {
  background-color: #2d2d2db3;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  transform: all 0.3s;
  color: #fff;
  display: none;
  text-align: center;
  flex-direction: column;
  padding: 0 2.3rem 0 2.3rem;
  animation: show-box 0.5s;
}

@media screen and (min-width: 991px) {
  .areas-item-box:hover .areas-modal-div {
    display: block;
    animation: dispaly-box 0.5s;
  }
}

.areas-modal-title {
  color: #fff;
  width: 100%;
  margin: 2rem 0 2rem 0;
  font-size: 1.25rem;
}

.areas-modal-content {
  color: #fff;
  width: 100%;
  line-height: 1.8rem;
  letter-spacing: 0.15rem;
}

.areas-modal-button {
  /* width: 100%; */
  position: absolute;
  bottom: 1rem;
  width: 35%;
  height: 2rem;
  background-color: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.2rem;
  margin: 0 auto;
  left: 34%;
}

@media screen and (max-width: 1620px) {
  .areas-list {
    width: 100%;
  }

  .areas-list-item {
    width: 30%;
    transition-duration: 0.8s;
  }

  .areas-body-div {
    background-color: #fff;
    transition-duration: 0.8s;
    margin-top: 12rem;
  }
}

@media screen and (max-width: 1218px) {
  .areas-list {
    width: 100%;
  }

  .areas-list-item {
    width: 40%;
    transition-duration: 0.8s;
  }

  .areas-body-div {
    background-color: #fff;
    transition-duration: 0.8s;
  }
}

@media screen and (max-width: 991px) {
  .areas-body-div {
    margin-top: 7rem;
  }
}
</style>